import { Card, ProgressBar } from "react-bootstrap";


const ChemotherapyProgress = ({ progressStats = {}, totalCycles = 0 }) => {
  const {
    completed = 0,
    progress,
    remaining = 0,
    totalSlots = 0,
    pending = 0,
  } = progressStats;

  return (
    <Card className="figma-card">
      {/* HEADER */}
      <div className="figma-header">
        <div>
          <h6>Chemotherapy Progress</h6>
          <p>Track your treatment journey</p>
        </div>

      </div>

      <Card.Body className="custom-card-body">
        <h2 className="session-count">
          <span className="current">{completed}</span>
          <span className="total"> / {totalSlots}</span>
          <span className="sessions"> sessions</span>
        </h2>

        <div className="progress-info">
          <span>Progress</span>
          <span className="percent">{progress}%</span>
        </div>

        <ProgressBar now={progress} className="figma-progress" />

        <p className="remaining">
          {remaining} {remaining === 1 ? "session" : "sessions"} remaining
        </p>

        <div className="stats">
          <div className="stat blue">
            <p>Total Chemo Sessions</p>
            <h5>{totalSlots}</h5>
          </div>
          <div className="stat green">
            <p>Completed</p>
            <h5>{completed}</h5>
          </div>
          <div className="stat orange">
            <p>Pending</p>
            <h5>{pending}</h5>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ChemotherapyProgress;